export const autoLabelDatabase = [
    {
        idCode: 'fmo@@@LddTTVbvebQbrTyjUcNBfjjjjjjjjjh@Oz[PG]cAhMv\\anulMvLSnqiuFzNYwXt[c][B[iZS]SJ{lXmin}c]vLflw\\sn{Fs^{lZlGnqnt^{FGI{lYmgni`q^zfSU{jZLwnilw^zfKC{jZmOninr~zf[@',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLxi]BWP`QLesvWPi\\}?i~WP`',
        mf: 'C27H48',
        mw: 372.67812,
        label: 'cholesterol',
    },
    {
        idCode: 'flm@@@LddTTVbvebyjUcNBfjjjjjjj@C~fTAwXpZC]gH[m[C]cD{lZ]Qncf]vMFxwVpfzVdwTrn{FKZ[oXw]cIkMwL{nqlwn{FkA{l[mGnqar^{F[@',
        coordinates: '!BetK~gzaBM`BWO_z`esvhOZ`}etK~gy]BjDK~hL~esyhqXNLx',
        mf: 'C19H32',
        mw: 260.46308,
        label: 'steroid',
    },
    {
        idCode: 'fhe@@@LdbbbTReryHQmN|Fjjjjjj`@iE@TzCFCHavFMFIUjTYcFK\\npfLfeMeQ[TfLqlufMV]YoL[lEcM`',
        coordinates: '!BbOvw?_x@?g~H@k\\B?g~w@k_}bOvH?_x@GvVH@a|ZTq`',
        mf: 'C17H28',
        mw: 232.40931999999998,
        label: 'steroid-core',
    },
    {
        idCode: 'daDD@@qJYnnjjh@hrPwXrMvlS]STwRsMums]s@',
        coordinates: '!Bm?vH?[_|?g?~_x`BbOt',
        mf: 'C6H12O2',
        mw: 116.15928000000001,
        label: 'pyranose',
    },
    {
        idCode: 'gOp`AdifMjj`OzUHwXr[iXmuMV{f[]k@',
        coordinates: '!BTv]`YW?~KF_~_q`l',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'furanose',
    },
    {
        idCode: 'gOp`Adigkjj`OzUHwXr[mXmuMVzV[]s@',
        coordinates: '!Bm?vH?[_|?g?~_xc}',
        mf: 'C5H10O2',
        mw: 102.1324,
        label: 'pyranose-core',
    },
    {
        idCode: 'gFp`AdidvjhC~aRMvLfzVK]SUny`',
        coordinates: '!BTv]`YW?~KF_~_p',
        mf: 'C4H8O2',
        mw: 88.10552,
        label: 'furanose-core',
    },
];
//# sourceMappingURL=autoLabelDatabase.js.map